export { default } from '@material-ui/icons/MoreHoriz';
